import React from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import { useState } from "react";
import { triggerNotification } from "../../component/message/Msg";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../config";
import { useEffect } from "react";
import Spinner from "../../component/loadingbar/Spinner";

const AddSubject = () => {
  const [loading, setLoading] = useState(false);
  const [subject, setSubject] = useState("");

  const { id } = useParams();
  const token = config.token;
  const navigate = useNavigate();

  const handleSubjectChange = (e) => {
    setSubject(e.target.value);
  };

  //-------------------------------------- clear form data --------------------------------------r
  const clearForm = () => {
    setSubject("");

    if (id) {
      navigate("/viewsubjects");
    }
  };
  //---------------------------------------------- get data for update / edit subject ----------------------------------------------------r
  useEffect(() => {
    if (id !== undefined) {
      setLoading(true);
      fetch(`${config.host_url}subject/${decodeURIComponent(atob(id))}`, {
        method: "GET",
        headers: {
          token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setSubject(data.data.subject);
          console.log(data.data);
          setLoading(false);
        });
    }
  }, [id]);

  // ---------------------------------------------- create / add Subject ----------------------------------------------------c
  // Function to create a new Subject
  const addSubjectBtn = async () => {
    try {
      if (!subject.trim()) {
        triggerNotification("error", "Input fields cannot be empty!!");
        return;
      }

      fetch(
        `${config.host_url}subject/${id ? decodeURIComponent(atob(id)) : ""}`,
        {
          method: `${id ? "PUT" : "POST"}`,
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
          body: JSON.stringify({
            subject: subject,
          }),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            // Course created successfully
            triggerNotification(
              "success",
              `${
                id
                  ? "Subject updated successfully."
                  : "Subject created successfully."
              }`
            );
            setSubject("");
            navigate("/viewsubjects");
          } else if (data.status === 400) {
            // Handle validation errors
            triggerNotification("error", "Validation Error.");
          } else if (data.status === 401) {
            // Handle unauthorized (invalid token)
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other server errors
            triggerNotification("error", "Internal server error.");
          }
        })
        .catch((error) => {
          triggerNotification("error", "Please try after sometime");
          console.error("Fetch error:", error);
        });
    } catch (error) {
      console.error("Error creating Subject:", error);
      triggerNotification(
        "error",
        "An error occurred while creating the Subject."
      );
    }
  };

  return (
    <>
      <Breadcrumb txt="Manage Subject" subpath={["Add Subject"]} />
      {/* form view */}
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center ">
            <h5 className="mb-0">Add Subject</h5>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="card-body">
              <form>
                {/* Subject Name */}
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control"
                    name="cls"
                    id="cls"
                    placeholder="Subject Name"
                    value={subject}
                    onChange={handleSubjectChange}
                  />
                  <label htmlFor="cls"> Subject Name</label>
                </div>
                {/* submit */}
                <div className="mt-3 justify-content-end">
                  <div className="col-sm-10">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={addSubjectBtn}
                    >
                      {id ? "update" : "Submit"}
                    </button>
                    {/* clear | calcel */}
                    <button
                      type="button"
                      className="btn ml-2 btn-secondary"
                      onClick={clearForm}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddSubject;
